import { KeycloakEventType, KeycloakService } from 'keycloak-angular';
import { EnvironmentService } from './environment.service';

export function initializeKeycloak(keycloak: KeycloakService, environmentService: EnvironmentService)
{
  return (): Promise<any> => {   
     return environmentService.loadConfig().then(config => {
      // console.log('enviromment variables on init from InitializeKeycloak method')
      // console.log('url', config.Keycloakconfig.url)
      // console.log('realm', config.Keycloakconfig.realm)
      // console.log('clientId', config.Keycloakconfig.clientId)
      // console.log('backendAPI', config.BackendApi)
      

      return keycloak.init({
        config : {
          url : config.Keycloakconfig.url,
          realm : config.Keycloakconfig.realm,
          clientId : config.Keycloakconfig.clientId,
        },
        loadUserProfileAtStartUp: true,
        enableBearerInterceptor: true,
        initOptions : {
          onLoad: config.KeycloakinitOptions.onLoad,
          flow: config.KeycloakinitOptions.flow
        },
        shouldAddToken: (request) => {
          const { method, url } = request;
      
          const isGetRequest = 'GET' === method.toUpperCase();
          const acceptablePaths = ['/health',];
          const isAcceptablePathMatch = acceptablePaths.some((path) =>
            url.includes(path)
          );
          return !(isGetRequest && isAcceptablePathMatch);
          
        }
  
      })
  });
    } 
    
}
